import { div } from 'common/dom/primitives';
import { IDisposable, disposable } from 'common/disposable';
import { Range } from 'immutable';

import 'common/styles/block.less';

const blockCountKey = 'blockcount';
const blockDisposableKey = 'blockdisposable';

export function block($element: JQuery, shieldClass?: string, shieldContent?: () => JQuery): IDisposable {
    const blockCount = $element.data(blockCountKey);

    if (blockCount === undefined) {
        const $shield = div('studio-block-shield').attr('tabindex', 0).appendTo($element);

        if (shieldClass)
            $shield.addClass(shieldClass);

        if (shieldContent)
            $shield.append(shieldContent());

        const inputBlocked = blockInput($element);

        const blockDisposable = disposable(() => {
            inputBlocked.dispose();
            $shield.remove();
        });

        $element.data(blockCountKey, 1);
        $element.data(blockDisposableKey, blockDisposable);
    }
    else {
        $element.data(blockCountKey, blockCount + 1);
    }
    
    return disposable(() => {
        const blockCount = $element.data(blockCountKey);

        if (blockCount === 1) {
            $element.data(blockDisposableKey).dispose();
            $element.removeData(blockCountKey);
            $element.removeData(blockDisposableKey);
        }
        else {
            $element.data(blockCountKey, blockCount - 1);
        }
    });
}


export function blockBusy($element: JQuery, shieldClass?: string): IDisposable {
    return block(
        $element,
        `studio-block-shield-visual${(shieldClass ? ' ' + shieldClass : '')}`,
        () => div('studio-busy-indicator').append(div('studio-busy-indicator-content').append(Range(0, 12).map(() => div()).toArray()))
    );
}

export function blockDark($element: JQuery, customStyle?: string): IDisposable {
    return block($element, `studio-block-shield-dark${customStyle ? ' ' + customStyle : ''}`);
}

export function blockInput($element: JQuery): IDisposable {
    const keyHandler = e => {
        e.preventDefault();
        e.stopPropagation();
        e.returnValue = false;
        return false;
    };

    $element.addClass('studio-blocked').on('keydown', keyHandler);

    return disposable(() => $element.removeClass('studio-blocked').off('keydown', keyHandler));
}